<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Contacto
        </div>
      </div>
      <div class="card-body pb-5">
        <hr class="mt-4"/>
        <!--begin: Bank Data -->
          <div class="row mt-4">
            <div class="col-sm col-md col-lg">
              <h4 class="m--font-info">Contacto</h4>
            </div>
          </div>
          <sys-form :inputs.sync="investor_contact"/>
        <!--end: Bank Data -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'investors' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'InvestorBankDataCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      investor_contact: {
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 6,
          validate: 'required'
        },
        email: {
          name: 'Email',
          hint: 'Email',
          value: '',
          type: 'email',
          size: 6
        },
        telephone: {
          name: 'Telefono',
          hint: 'Telefono',
          value: '',
          type: 'text',
          size: 4,
          validate: 'required'
        },
        mobile: {
          name: 'Telefono Movil',
          hint: 'Telefono Movil',
          value: '',
          type: 'text',
          size: 4
        },
        role: {
          name: 'Puesto/Relacion',
          hint: 'Puesto/Relacion',
          value: '',
          type: 'text',
          size: 4
        }
      }
    }
  },

  created: function () {
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = {
            contact: this.processForm(this.investor_contact)
          }
          let investorId = this.$route.params.investor_id

          let service = investorsService.postContact(investorId, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'investor', params: { id: investorId } })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/investors/contacts/ContactCreate.vue